export type RuntimeConfig = {
  apiUrl: string;
  auth0Domain: string;
  auth0ClientId: string;
  auth0Audience: string;
};

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<RuntimeConfig>;
  }
}

// Injected by /config.js, which the container entrypoint templates from runtime
// env at startup — so one image serves every environment. Local dev / preview /
// E2E ship an empty placeholder (public/config.js) and fall through to Vite's
// build-time import.meta.env.
export function getRuntimeConfig(): RuntimeConfig {
  const injected = typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined;
  return {
    apiUrl: injected?.apiUrl || import.meta.env.VITE_API_URL,
    auth0Domain: injected?.auth0Domain || import.meta.env.VITE_AUTH0_DOMAIN,
    auth0ClientId: injected?.auth0ClientId || import.meta.env.VITE_AUTH0_CLIENT_ID,
    auth0Audience: injected?.auth0Audience || import.meta.env.VITE_AUTH0_AUDIENCE,
  };
}
